module.exports = "https://cdn-assessment.mathletics.com/app/102/assets/images/4e6dfd022179eec43c12b4d24874a8b3.svg";